import { createAsync, query } from "@solidjs/router";
import { For } from "solid-js";

const getCertifiers = query( async () => {
	const { getCertifiersQueryServer } = await import( "~/_server/dynamoQueries" );

	return await getCertifiersQueryServer();
}, "getCertifiers" );

export default  () => {
	const certifiers = createAsync( () => getCertifiers(), { deferStream: true } );

	return (
		<div class="rias-content col-span-full">
			<h1>Design Certifiers</h1>

			<p>Coming soon!</p>

			{/*
			<For each={certifiers()?.items} >
				{
					certifier => (
						<div class="certifier"><h3>{certifier.name}</h3>
							<h5><em>Certification of Design (Section 6 - Energy) for Domestic Buildings</em></h5>
							<strong>Richard Atkins, Chartered Architect</strong>
							<br />1, Carlaverock Farm Cottage, Tranent, East Lothian, EH33 2NF
							<br />01875 614105
							<br />
							<a href={`mailto:${certifier.email}`}>{certifier.email}</a>
						</div> )
				}
			</For>
			*/}
		</div>
	);
}
